import React from "react";

const STATUS_MAP = {
  active: { label: "Ativo", bg: "#D1FAE5", fg: "#065F46" },
  expiring: { label: "Expira em breve", bg: "#FEF3C7", fg: "#92400E" },
  expired: { label: "Expirado", bg: "#FEE2E2", fg: "#991B1B" },
  no_date: { label: "Sem data", bg: "#F3F4F6", fg: "#374151" },
};

export default function StatusBadge({ status, testId }) {
  const s = STATUS_MAP[status] || STATUS_MAP.no_date;
  return (
    <span
      className="vp-pill"
      style={{ background: s.bg, color: s.fg }}
      data-testid={testId || `status-badge-${status}`}
    >
      <span style={{ width: 6, height: 6, borderRadius: 9999, background: s.fg, opacity: 0.7 }} />
      {s.label}
    </span>
  );
}
